import { render, staticRenderFns } from "./UserPayout.vue?vue&type=template&id=33e429b2&lang=pug"
import script from "./UserPayout.vue?vue&type=script&lang=js"
export * from "./UserPayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports